/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { Injectable } from '@angular/core';

import { ApiService } from 'rest-client';

import { ACCEPTED_COOKIE } from '@app/modules/shared/const/cookies.consts';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ActiveCampaignService {
  private acId: string;
  vgo: Function;

  private browserGlobals = {
    windowRef(): any {
      return window;
    },
    documentRef(): any {
      return document;
    },
  };

  constructor(private unauthenticatedApi: ApiService) {
    this.acId = environment.activeCampaignId;
  }

  addActiveCampaignToDoM(): void {
    const doc = this.browserGlobals.documentRef();
    const acScript = doc.createElement('script');
    const acScript_inner = doc.createElement('script');

    acScript.id = 'ACscript';
    acScript.async = true;
    acScript.src = 'https://diffuser-cdn.app-us1.com/diffuser/diffuser.js';
    acScript_inner.innerHTML = `(function(e,t,o,n,p,r,i){e.visitorGlobalObjectAlias=n;e[e.visitorGlobalObjectAlias]=e[e.visitorGlobalObjectAlias]||function(){(e[e.visitorGlobalObjectAlias].q=e[e.visitorGlobalObjectAlias].q||[]).push(arguments)};e[e.visitorGlobalObjectAlias].l=(new Date).getTime();r=t.createElement("script");r.src=o;r.async=true;i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)})(window,document,"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js","vgo");
    vgo('setAccount', '68359332');

    if(localStorage.getItem('aparcandgo_cookies_accepted') === 'accept'){
      vgo('setTrackByDefault', true);
    } else {
      vgo('setTrackByDefault', false);
    }
    
    if(localStorage.getItem('auth_token') !== null){
      var parseAuth = JSON.parse(localStorage.getItem('auth_token'))
      vgo('setEmail', parseAuth.user.email)
    }

    vgo('process');

    `;

    document.documentElement.firstChild.appendChild(acScript_inner);
    document.documentElement.firstChild.appendChild(acScript);

    const scope = this;

    acScript.onload = function (): void {
      scope.getVgo();

      /* if (scope.checkCookies()) {
        scope.setAllowTracking();
      }*/
    };
  }

  getVgo(): any {
    const window = this.browserGlobals.windowRef();
    window['vgo'] = window['vgo'] || [];
    this.vgo = window['vgo'];
  }

  setAllowTracking(): void {
    if (this.vgo && typeof this.vgo === 'function') {
      this.vgo('process', 'allowTracking');
    }
  }

  setACEmail(email: string): void {
    if (this.vgo && typeof this.vgo === 'function') {
      this.vgo('setEmail', email);
      this.vgo('process');
    }
  }

  private checkCookies(): boolean {
    switch (localStorage.getItem(ACCEPTED_COOKIE)) {
      case 'accept':
        return true;
      case 'reject':
        return false;
      default:
        return false;
    }
  }
}
